<template>

	<div @click="hrefNavTo(imgItem.link)" style="max-width: 100%;position: relative;overflow: hidden;cursor: pointer;"
		@mouseenter.stop.prevent="isEnter = true" @mouseleave.stop.prevent="isEnter = false" :style="{
		...getBorderRadius(),
		...getBorder(),
		...getHoverBorder(),
		...getBgColor(),
		...getPadding()
	}">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>

		<div v-if="selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'"
			:style="{
				aspectRatio: getAspectRatioImg(selectdItem.compontChildren[0].layoutConfig.img),
			}"
			style="width: 100%; position: relative;display: flex;justify-content: center;flex-direction: column;align-items: center;">
			<!-- <img @click="navTo()" :style="{
				objectFit:selectdItem.compontChildren[0].layoutConfig.img.mode?selectdItem.compontChildren[0].layoutConfig.img.mode:'cover',
				width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.width + 'px' : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth + 'px',
				height:equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.height + 'px' :  selectdItem.compontChildren[0].layoutConfig.img.phoneHeight + 'px',
			}" style="max-width: 100%;" :src="imgItem.url" /> -->
			
			<img 
			@mouseenter.stop.prevent="handleMouseEnter"
			@mouseleave.stop.prevent="handleMouseLeave"
			loading="lazy" :style="{
				...imageStyle,
				objectFit:selectdItem.compontChildren[0].layoutConfig.img.mode?selectdItem.compontChildren[0].layoutConfig.img.mode:'cover',
				aspectRatio:getAspectRatio(selectdItem.compontChildren[0].layoutConfig.img),
				
				width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.width + 'px' : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth + 'px',
				// height:equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.height + 'px' :  selectdItem.compontChildren[0].layoutConfig.img.phoneHeight + 'px',
				// width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.width + 'px' : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth + 'px',
				// height:equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.height + 'px' :  selectdItem.compontChildren[0].layoutConfig.img.phoneHeight + 'px',
			}" style="max-width: 100%;" :src="imgItem.url" />

			<div v-if="imgItem.tit1 && selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg"
				style="position: absolute;opacity: 0.85;font-weight: bold;" :style="{
				...getTitInImgStyle('tit1',selectdItem.compontChildren[0].layoutConfig.img.tit),
				
			}">
				{{imgItem.tit1}}
			</div>

			<div v-if="imgItem.tit2 && selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg"
				style="position: absolute;opacity: 0.85;font-weight: bold;" :style="{
				...getTitInImgStyle('tit2',selectdItem.compontChildren[0].layoutConfig.img.tit),
				
			}">
				{{imgItem.tit2}}
			</div>

			<div v-if="imgItem.tit1 && !selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg"
				style="font-weight: bold;max-width: 100%;text-align: center;background-color: aliceblue;" :style="{
				...getTitInImgStyle('tit1',selectdItem.compontChildren[0].layoutConfig.img.tit),
				
			}">
				{{imgItem.tit1}}
			</div>

			<div v-if="imgItem.tit2 && !selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg"
				style="font-weight: bold;max-width: 100%;text-align: center;background-color: aliceblue;" :style="{
				...getTitInImgStyle('tit2',selectdItem.compontChildren[0].layoutConfig.img.tit),
				
			}">
				{{imgItem.tit2}}
			</div>
		</div>

		<div v-if="selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'lr'"
			style="width: 100%; position: relative;display: flex;justify-content: center;align-items: center;">
			<div style="min-height: 0;" :style="{
				aspectRatio: getAspectRatioImg(selectdItem.compontChildren[0].layoutConfig.img),
					// width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.width + 'px' : selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneWidth + 'px',
					// height:equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.height + 'px' :  selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneHeight + 'px',
				}">
				<img
				@mouseenter.stop.prevent="handleMouseEnter"
				@mouseleave.stop.prevent="handleMouseLeave"
				 loading="lazy" :style="{
					 ...imageStyle,
					objectFit:selectdItem.compontChildren[0].layoutConfig.img.mode?selectdItem.compontChildren[0].layoutConfig.img.mode:'cover',
					aspectRatio:getAspectRatio(selectdItem.compontChildren[0].layoutConfig.img),
					width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.width + 'px' : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth + 'px',
					// height:equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.height + 'px' :  selectdItem.compontChildren[0].layoutConfig.img.phoneHeight + 'px',
					// width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.width + 'px' : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth + 'px',
					// height:equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.height + 'px' :  selectdItem.compontChildren[0].layoutConfig.img.phoneHeight + 'px',
				}" style="max-width: 100%;" :src="imgItem.url" />
			</div>
			<div :style="{
				width:getLRTitWidth(),
			}">
				<div v-if="imgItem.tit1" style="white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;" :style="{
					...getTitInImgStyleLR('tit1',selectdItem.compontChildren[0].layoutConfig.img.tit)
				}">
					{{imgItem.tit1}}
				</div>
				<div v-if="imgItem.tit2" style="white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;" :style="{
					...getTitInImgStyleLR('tit2',selectdItem.compontChildren[0].layoutConfig.img.tit)
				}">
					{{imgItem.tit2}}
				</div>
			</div>
			
			<!-- <div :style="{
				width:getLRTitWidth(),
			}">
				<div v-if="imgItem.tit1" style="white-space:pre-wrap;word-wrap: break-word;" :style="{
					...getTitInImgStyleLR('tit1',selectdItem.compontChildren[0].layoutConfig.img.tit),
					width:getLRTitWidth(),
				}">
					{{imgItem.tit1}}
				</div>
				<div v-if="imgItem.tit2" style="white-space:pre-wrap;word-wrap: break-word;" :style="{
					...getTitInImgStyleLR('tit2',selectdItem.compontChildren[0].layoutConfig.img.tit),
					width:getLRTitWidth(),
				}">
					{{imgItem.tit2}}
				</div>
			</div> -->
			
		</div>


	</div>

</template>

<script>
	import {
		Select
	} from 'element-ui'

	import {
		getProductsAutocomplete,
		getproductsDetail,
		getDesignProductsDetail,
		getAccountAddCarts,
		getAccountCollect
	} from '../../api/all.js'
	import {
		getUrl_name
	} from '../../api/all.js'

	export default {
		props: {
			imgItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		computed: {
			imageStyle() {
				return {
					transform: this.isHovered ? 'scale(1.2)' : 'scale(1)',
					transition: 'transform 0.3s ease-in-out',
				};
			},
		},
		data() {
			return {
				isHovered:false,
				loading: false,
				dialogVisible: false,
				iframeLogin: false,
				isEnter: false
			}
		},
		mounted() {

			console.log('systemConfig', this.systemConfig)
			// window.addEventListener('message', this.handleMessage);
		},
		beforeDestroy() {
			// window.removeEventListener('message', this.handleMessage);
		},
		methods: {
			handleMouseEnter(){
				if(this.selectdItem.compontChildren[0].layoutConfig.img.isScale == 'yes'){
					this.isHovered = true
				}
			},
			handleMouseLeave(){
				this.isHovered = false
			},
			
			getAspectRatioImg(item){
				
				if(this.equipment == 'pc'){
					if(item.width == item.height) {
						return `1/1`
					}else{
						return `${item.width} / ${item.height}`
					}
				}else{
					if(item.phoneWidth == item.phoneHeight) {
						return `1/1`
					}{
						return `${item.phoneWidth} / ${item.phoneHeight}`
					}
				}
				
			},
			getAspectRatio(item) {
				console.log('${item.width} / ${item.height}',`${item.width} / ${item.height}`)
				if(this.equipment == 'pc'){
					return `${item.width} / ${item.height}`
				}else{
					return `${item.phoneWidth} / ${item.phoneHeight}`
				}
			},

			async hrefNavTo(item) {





				if (this.type == 'design') {
					return
				}
				console.log('hrefNavToitem', item)
				if (item.cacheLinkIndex == '首页') {
					this.$router.push({
						path: '/'
					})
					this.show = false
					return
				}
				
				if(item.cacheLinkIndex == '热销商品') {
					this.$router.push({
						path: '/categories_products/hot'
					})
					this.show = false
					return
				}
				if(item.cacheLinkIndex == '最新商品') {
					this.$router.push({
						path: '/categories_products/new'
					})
					this.show = false
					return
				}
				
				if(item.cacheLinkIndex == '浏览最多') {
					this.$router.push({
						path: '/categories_products/visit'
					})
					this.show = false
					return
				}
				if(item.cacheLinkIndex == '所有商品') {
					this.$router.push({
						path: '/categories_products/all'
					})
					this.show = false
					return
				}


				if (item.cacheLinkIndex == '商品分类') {
					try {
						this.loading = true
						this.show = false
						const urlData = await getUrl_name({
							type: "categories",
							id: item.link.id
						})


						this.$router.push({
							path: '/categories/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}
				if (item.cacheLinkIndex == '商品') {

					try {
						this.loading = true
						this.show = false
						const urlData = await getUrl_name({
							type: "products",
							id: item.link.id
						})
						this.$router.push({
							path: '/products/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}
				let url = item.link.url
				if (item.link.type == '站内链接') {
					// 判断是否是站内链接
					console.log('item.link', item.link)
					console.log(window.location.host)
					if (item.link.name.indexOf(window.location.host) != -1) {
						let arr = item.link.name.split(window.location.host)
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						return
					} else {
						this.show = false
						window.open(item.link.name);
						return
					}
				}
				this.show = false
				if (url) {
					this.$router.push({
						path: '/' + url,
					})
				}

			},

			hexToRgba(hex, opacity = 1) {
				// 移除#号
				hex = hex.replace('#', '');

				// 处理3位简写颜色
				if (hex.length === 3) {
					hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
				}

				// 转换为十进制
				const r = parseInt(hex.substring(0, 2), 16);
				const g = parseInt(hex.substring(2, 4), 16);
				const b = parseInt(hex.substring(4, 6), 16);

				// 确保透明度在0-1之间
				const alpha = Math.min(1, Math.max(0, opacity));

				return `rgba(${r}, ${g}, ${b}, ${alpha})`;
			},


			getLRTitWidth() {
				let imgWidth = 0;
				if (this.equipment == 'pc') {
					imgWidth = this.selectdItem.compontChildren[0].layoutConfig.img.width
				} else {
					imgWidth = this.selectdItem.compontChildren[0].layoutConfig.img.phoneWidth
				}
				let paddingWidth = parseInt(this.selectdItem.compontChildren[0].layoutConfig.img.padding[1]) + parseInt(this.selectdItem.compontChildren[0].layoutConfig.img.padding[3])
				let borderWidth = parseInt(this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[1]) + parseInt(this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[3])
				return `calc(100% - ${imgWidth}px)`
			},
			getTitInImgStyleLR(type, item) {
				if (type == 'tit1') {
					// 获取位置
					let style = {}
					if (item.tit1Position == 'center') {}
					if (item.tit1Position == 'top') {
						style.top = '0px'
					}
					if (item.tit1Position == 'bottom') {
						style.bottom = '0px'
					}
					if (item.tit1Position == 'left') {
						style.left = '0px'
						style.alignSelf = 'center'
					}
					if (item.tit1Position == 'right') {
						style.right = '0px'
						style.alignSelf = 'center'
					}

					// 字体
					style.fontSize = item.tit1Size + 'px'
					style.color = item.tit1Color
					style.fontFamily = item.tit1Family

					if (this.isEnter) {
						if (item.tit1HoverColor) {
							style.color = item.tit1HoverColor
						}
					}

					// 背景

					if (item.tit1Bg.type == '1') {
						style = {
							...style,
							backgroundColor: item.tit1Bg.color
						}
					}
					if (item.tit1Bg.type == '2') {
						style = {
							...style,
							...this.cssStringToObject(item.tit1Bg.gradientColor)
						}
					}

					// 内边距
					style.paddingTop = item.tit1Padding[0] + 'px',
						style.paddingBottom = item.tit1Padding[1] + 'px',
						style.paddingLeft = item.tit1Padding[2] + 'px',
						style.paddingRight = item.tit1Padding[3] + 'px'


					// 外边距
					style.marginTop = item.tit1Margin[0] + 'px',
						style.marginBottom = item.tit1Margin[1] + 'px',
						style.marginLeft = item.tit1Margin[2] + 'px',
						style.marginRight = item.tit1Margin[3] + 'px'

					// 组件边框
					if (item.tit1Border.type && item.tit1Border.color) {
						style.borderTop =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[0]}px ${item.tit1Border.color}`
						style.borderLeft =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[1]}px ${item.tit1Border.color}`
						style.borderBottom =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[2]}px ${item.tit1Border.color}`
						style.borderRight =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[3]}px ${item.tit1Border.color}`
					}




					style.borderRadius =
						`${item.tit1Border.borderRadius[0]}px ${item.tit1Border.borderRadius[1]}px ${item.tit1Border.borderRadius[2]}px ${item.tit1Border.borderRadius[3]}px`

					// tit1InImg
					// tit2InImg
					// if(!item.tit1InImg) {
					// }
					// let imgWidth = 1;
					// if (this.equipment == 'pc') {
					// 	imgWidth = this.selectdItem.compontChildren[0].layoutConfig.img.width
					// } else {
					// 	imgWidth = this.selectdItem.compontChildren[0].layoutConfig.img.phoneWidth
					// }
					style.width =
						`calc(100% - ${ parseInt(item.tit1Padding[2]) + parseInt(item.tit1Padding[3]) + parseInt(item.tit1Margin[2]) + parseInt(item.tit1Margin[3]) + parseInt(item.tit1Border.borderSize[1]) + parseInt(item.tit1Border.borderSize[3])}px)`

					console.log('style.widthstyle.width123456', style)
					return style
				}

				if (type == 'tit2') {
					// 获取位置
					let style = {}
					if (item.tit2Position == 'center') {}
					if (item.tit2Position == 'top') {
						style.top = '0px'
					}
					if (item.tit2Position == 'bottom') {
						style.bottom = '0px'
					}
					if (item.tit2Position == 'left') {
						style.left = '0px'
						style.alignSelf = 'center'
					}
					if (item.tit2Position == 'right') {
						style.right = '0px'
						style.alignSelf = 'center'
					}

					// 字体
					style.fontSize = item.tit2Size + 'px'
					style.color = item.tit2Color
					style.fontFamily = item.tit2Family

					if (this.isEnter) {
						if (item.tit2HoverColor) {
							style.color = item.tit2HoverColor
						}
					}

					// 背景

					if (item.tit2Bg.type == '1') {
						style = {
							...style,
							backgroundColor: item.tit2Bg.color
						}
					}
					if (item.tit2Bg.type == '2') {
						style = {
							...style,
							...this.cssStringToObject(item.tit2Bg.gradientColor)
						}
					}

					// 内边距
					style.paddingTop = item.tit2Padding[0] + 'px',
						style.paddingBottom = item.tit2Padding[1] + 'px',
						style.paddingLeft = item.tit2Padding[2] + 'px',
						style.paddingRight = item.tit2Padding[3] + 'px'

					// 外边距
					style.marginTop = item.tit2Margin[0] + 'px',
						style.marginBottom = item.tit2Margin[1] + 'px',
						style.marginLeft = item.tit2Margin[2] + 'px',
						style.marginRight = item.tit2Margin[3] + 'px'

					// 组件边框
					if (item.tit2Border.type && item.tit2Border.color) {
						style.borderTop =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[0]}px ${item.tit2Border.color}`
						style.borderLeft =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[1]}px ${item.tit2Border.color}`
						style.borderBottom =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[2]}px ${item.tit2Border.color}`
						style.borderRight =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[3]}px ${item.tit2Border.color}`
					}

					style.borderRadius =
						`${item.tit2Border.borderRadius[0]}px ${item.tit2Border.borderRadius[1]}px ${item.tit2Border.borderRadius[2]}px ${item.tit2Border.borderRadius[3]}px`

					// if(!item.tit2InImg) {
					// }
					// style.width = `calc(100% - ${})` 

					let imgWidth = 1;
					// if (this.equipment == 'pc') {
					// 	imgWidth = this.selectdItem.compontChildren[0].layoutConfig.img.width
					// } else {
					// 	imgWidth = this.selectdItem.compontChildren[0].layoutConfig.img.phoneWidth
					// }

					style.width =
						`calc(100% - ${parseInt(imgWidth) + parseInt(item.tit2Padding[2]) + parseInt(item.tit2Padding[3]) + parseInt(item.tit2Margin[2]) + parseInt(item.tit2Margin[3]) + parseInt(item.tit2Border.borderSize[1]) + parseInt(item.tit2Border.borderSize[3])}px)`
					console.log('stylestyle000123', style)
					return style


				}

			},


			getTitInImgStyle(type, item) {
				console.log('itemitemitem', item)
				if (type == 'tit1') {
					// 获取位置
					let style = {}
					if (item.tit1Position == 'center') {}
					if (item.tit1Position == 'top') {
						style.top = '0px'
					}
					if (item.tit1Position == 'bottom') {
						style.bottom = '0px'
					}
					if (item.tit1Position == 'left') {
						style.left = '0px'
						style.alignSelf = 'center'
					}
					if (item.tit1Position == 'right') {
						style.right = '0px'
						style.alignSelf = 'center'
					}

					// 字体
					style.fontSize = item.tit1Size + 'px'
					style.color = item.tit1Color
					style.fontFamily = item.tit1Family

					if (this.isEnter) {
						if (item.tit1HoverColor) {
							style.color = item.tit1HoverColor
						}
					}

					// 背景

					if (item.tit1Bg.type == '1') {
						style = {
							...style,
							backgroundColor: item.tit1Bg.color
						}
					}
					if (item.tit1Bg.type == '2') {
						style = {
							...style,
							...this.cssStringToObject(item.tit1Bg.gradientColor)
						}
					}

					// 内边距
					style.paddingTop = item.tit1Padding[0] + 'px',
						style.paddingBottom = item.tit1Padding[1] + 'px',
						style.paddingLeft = item.tit1Padding[2] + 'px',
						style.paddingRight = item.tit1Padding[3] + 'px'
					// 外边距
					style.marginTop = item.tit1Margin[0] + 'px',
						style.marginBottom = item.tit1Margin[1] + 'px',
						style.marginLeft = item.tit1Margin[2] + 'px',
						style.marginRight = item.tit1Margin[3] + 'px'

					// 组件边框
					if (item.tit1Border.type && item.tit1Border.color) {
						style.borderTop =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[0]}px ${item.tit1Border.color}`
						style.borderLeft =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[1]}px ${item.tit1Border.color}`
						style.borderBottom =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[2]}px ${item.tit1Border.color}`
						style.borderRight =
							`${item.tit1Border.type} ${item.tit1Border.borderSize[3]}px ${item.tit1Border.color}`
					}

					style.borderRadius =
						`${item.tit1Border.borderRadius[0]}px ${item.tit1Border.borderRadius[1]}px ${item.tit1Border.borderRadius[2]}px ${item.tit1Border.borderRadius[3]}px`

					// tit1InImg
					// tit2InImg
					if (!item.tit1InImg) {
						style.width =
							`calc(100% - ${parseInt(item.tit1Padding[2]) + parseInt(item.tit1Padding[3]) + parseInt(item.tit1Margin[2]) + parseInt(item.tit1Margin[3]) + parseInt(item.tit1Border.borderSize[1]) + parseInt(item.tit1Border.borderSize[3])}px)`
					}

					console.log('style.widthstyle.width', style)
					return style
				}

				if (type == 'tit2') {
					// 获取位置
					let style = {}
					if (item.tit2Position == 'center') {}
					if (item.tit2Position == 'top') {
						style.top = '0px'
					}
					if (item.tit2Position == 'bottom') {
						style.bottom = '0px'
					}
					if (item.tit2Position == 'left') {
						style.left = '0px'
						style.alignSelf = 'center'
					}
					if (item.tit2Position == 'right') {
						style.right = '0px'
						style.alignSelf = 'center'
					}

					// 字体
					style.fontSize = item.tit2Size + 'px'
					style.color = item.tit2Color
					style.fontFamily = item.tit2Family

					if (this.isEnter) {
						if (item.tit2HoverColor) {
							style.color = item.tit2HoverColor
						}
					}

					// 背景

					if (item.tit2Bg.type == '1') {
						style = {
							...style,
							backgroundColor: item.tit2Bg.color
						}
					}
					if (item.tit2Bg.type == '2') {
						style = {
							...style,
							...this.cssStringToObject(item.tit2Bg.gradientColor)
						}
					}

					// 内边距
					style.paddingTop = item.tit2Padding[0] + 'px',
						style.paddingBottom = item.tit2Padding[1] + 'px',
						style.paddingLeft = item.tit2Padding[2] + 'px',
						style.paddingRight = item.tit2Padding[3] + 'px'

					// 外边距
					style.marginTop = item.tit2Margin[0] + 'px',
						style.marginBottom = item.tit2Margin[1] + 'px',
						style.marginLeft = item.tit2Margin[2] + 'px',
						style.marginRight = item.tit2Margin[3] + 'px'

					// 组件边框
					if (item.tit2Border.type && item.tit2Border.color) {
						style.borderTop =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[0]}px ${item.tit2Border.color}`
						style.borderLeft =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[1]}px ${item.tit2Border.color}`
						style.borderBottom =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[2]}px ${item.tit2Border.color}`
						style.borderRight =
							`${item.tit2Border.type} ${item.tit2Border.borderSize[3]}px ${item.tit2Border.color}`
					}

					style.borderRadius =
						`${item.tit2Border.borderRadius[0]}px ${item.tit2Border.borderRadius[1]}px ${item.tit2Border.borderRadius[2]}px ${item.tit2Border.borderRadius[3]}px`

					if (!item.tit2InImg) {
						style.width =
							`calc(100% - ${parseInt(item.tit2Padding[2]) + parseInt(item.tit2Padding[3]) + parseInt(item.tit2Margin[2]) + parseInt(item.tit2Margin[3]) + parseInt(item.tit2Border.borderSize[1]) + parseInt(item.tit2Border.borderSize[3])}px)`
					}
					console.log('stylestyle000', style)
					return style


				}

			},
			handleMessage(event) {
				let that = this
				console.log('eventeventevent', event)
				if (event && event.data.type == 'apiLoginResponse' && event.data.data.status == "success") {
					that.dialogVisible = false
					localStorage.setItem('address', JSON.stringify(event.data.data.data))
					// that.$message.success(event.data.data.message)
				}
			},


			navTo() {
				if (this.type == 'design') {
					return
				}
				// this.$router.push({
				// 	path: '/products/' + this.goodsData.url_name
				// })
			},
			getPadding() {
				let padding = this.selectdItem.compontChildren[0].layoutConfig.img.padding
				let style = {
					paddingTop: padding[0] + 'px',
					paddingBottom: padding[1] + 'px',
					paddingLeft: padding[2] + 'px',
					paddingRight: padding[3] + 'px'
				}
				return style
			},
			getBtnBgColor(btn, field) {
				if (btn[field].type == '1') {
					return {
						backgroundColor: btn[field].bgColor
					}
				} else {
					return {
						...this.cssStringToObject(btn[field].gradientColor)
					}
				}
			},

			getBgColor() {
				let bg = this.selectdItem.compontChildren[0].layoutConfig.img.bg
				if (bg.type == '1') {
					return {
						backgroundColor: bg.color
					}
				}
				if (bg.type == '2') {
					return this.cssStringToObject(bg.gradientColor)
				}


			},
			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getHoverBorder() {
				if (this.isEnter && this.selectdItem.compontChildren[0].layoutConfig.img.hoverShadow) {
					return {
						boxShadow: `0 0 10px 1px ${this.selectdItem.compontChildren[0].layoutConfig.img.hoverShadowColor}`
					}
				}
			},
			getColor(font, field, hoverField) {
				if (this.isEnter) {
					if (font[hoverField]) {
						return font[hoverField]
					} else {
						return font[field]
					}
				} else {
					return font[field]
				}
			},

			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[0]}px ${this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[1]}px ${this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[2]}px ${this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				let border = this.selectdItem.compontChildren[0].layoutConfig.img.border
				if (border.type && border.color) {
					let style = {}
					style.borderTop =
						`${border.type} ${border.borderSize[0]}px ${border.color}`
					style.borderLeft =
						`${border.type} ${border.borderSize[1]}px ${border.color}`
					style.borderBottom =
						`${border.type} ${border.borderSize[2]}px ${border.color}`
					style.borderRight =
						`${border.type} ${border.borderSize[3]}px ${border.color}`
					return style
				}
			},
		}
	}
</script>

<style scoped>
	.tit {
		overflow: hidden;
		/* 隐藏溢出内容 */
		white-space: nowrap;
		/* 禁止换行 */
		text-overflow: ellipsis;
		/* 显示省略号 */
	}

	.tit1:hover {
		color: var(--tit1HoverColor)
	}
</style>